// @ts-nocheck
import * as Types from "../../../types/types";

import { gql } from "@apollo/client";
export type PageAnalyticsFragment = {
  __typename?: "Organization";
  id: string;
  name: string;
  createdAt: number;
  onboardingProgress: {
    __typename?: "OrganizationOnboardingProgress";
    id: string;
    hasDatabasesIntegrated: boolean;
    hasRecentData: boolean;
    integratedCollector: boolean;
    integratedLogInsights: boolean;
    integratedExplain: boolean;
    integratedEmailAlerts: boolean;
  };
  planInfo: {
    __typename?: "OrganizationPlanInfo";
    id: string;
    subscriptionPlanId: string;
  };
};

export const PageAnalyticsFragmentDoc = gql`
  fragment PageAnalytics on Organization {
    id
    name
    createdAt
    onboardingProgress {
      id
      hasDatabasesIntegrated
      hasRecentData
      integratedCollector
      integratedLogInsights
      integratedExplain
      integratedEmailAlerts
    }
    planInfo {
      id
      subscriptionPlanId
    }
  }
`;
